import React from 'react';
import {connect} from 'react-redux';
import {Card, Header} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {retrieveRolesFromPermissions, checkIfIncludedsIn} from 'common/utils';
import _ from 'lodash';
import {ROLE_MAP} from 'app-ui-componentlibrary/dist/common/constants.js';
import REST from 'go/requests/rest';
import { hasGeneralPermission } from 'go/security/permissions';

export class MyOfficeWorkload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const fetchBody = {
      candidateGroups: this.props.permissions,
      includeAssignedTasks: true,
    };

    REST.workflow
      .getTaskCount(this.props.jwt, fetchBody)
      .then(REST.handler.handleResponse)
      .then((resJson) => {
        if (resJson) {
          this.setState(resJson);
          return resJson;
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  render() {
    const rolesList = retrieveRolesFromPermissions(this.props.permissions);
    if (
      checkIfIncludedsIn(rolesList, ROLE_MAP.PGMADMIN.code) ||
      checkIfIncludedsIn(rolesList, ROLE_MAP.PGMAO.code) ||
      checkIfIncludedsIn(rolesList, ROLE_MAP.GCA.code) ||
      checkIfIncludedsIn(rolesList, ROLE_MAP.SPGMADMIN.code) ||
      hasGeneralPermission('OFFICE_WORKLOAD_TRACKER')
    ) {
      return (
        <Card>
          <Card.Content>
            <Header as="h3">Office workload</Header>
            <Card.Meta>{this.state.count} tasks</Card.Meta>
            <Card.Description>
              <Link to={'/tasks/workload'} title="Office workload">
                View >
              </Link>
            </Card.Description>
          </Card.Content>
        </Card>
      );
    } else {
      return null;
    }
  }
}
export const mapStateToProps = (state) => {
  return {
    jwt: state.auth.token,
    permissions: state.auth.permissions,
  };
};

export default connect(mapStateToProps)(MyOfficeWorkload);
